namespace $.$$ {

	$mol_style_define( $shm_service_task_list, {
		width: '22rem',
		flex: { basis: '22rem', grow: 0, shrink: 0 },

		Tasks: {
			flex: {
				direction: 'column',
				grow: 1,
			},
		},

		List_head: {
			flex: { grow: 1 },
		},

		Task_link: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			minWidth: 0,
			width: 0,
			justifyContent: 'flex-start',
		},

		Task_row: {
			width: '100%',
			minWidth: 0,
			align: { items: 'center' },
			'[current]': {
				true: { color: $mol_theme.current },
			},
		},

		Task_info: {
			flex: { direction: 'column', grow: 1, shrink: 1, basis: 0 },
			minWidth: 0,
			width: '100%',
			overflow: 'hidden',
		},

		Task_title_row: {
			width: '100%',
			minWidth: 0,
			overflow: 'hidden',
			gap: '0.375rem',
			align: { items: 'center' },
		},

		Task_title: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
		},

		Task_markers: {
			flex: { grow: 0, shrink: 0 },
			gap: '0.25rem',
			align: { items: 'center' },
		},

		Task_meta: {
			minWidth: 0,
			width: '100%',
			whiteSpace: 'pre-line',
			color: $mol_theme.shade,
			font: { size: '0.75rem' },
		},

		Task_menu: {
			flex: { grow: 0, shrink: 0 },
			width: '2.5rem',
			Trigger: {
				width: '100%',
				minWidth: 0,
				padding: $mol_gap.text,
			},
		},

		Add_foot: {
			width: '100%',
			justifyContent: 'center',
			border: { radius: $mol_gap.round },
			padding: $mol_gap.text,
		},
	} )

}
